export default __webpack_public_path__ + "static/media/full_screen_illustration.1a086953.png";